import api from "../../api"
import { getSession } from "../../auth"
import { cortexGet, cortexDelete } from "./cortexFetch"

const fetchAllKnowledgeBases = async (assistantUrl, accessToken, accountcode) => {
    let kbs = []
    let next = `/ai/knowledge_bases/?accountcodeId=${accountcode}`

    while (next) {
        const res = await cortexGet(`${assistantUrl.split('/v')[0]}${next}`, accessToken)
        if (res.status !== 200) break
        const data = await res.json()
        kbs = [...kbs, ...(data.KnowledgeBases || [])]
        next = data.Next
    }

    return kbs
}

// Standalone equivalent of the old embedded widget's window.closeExternalId:
// deletes the Cortex conversation for a ticket across every knowledge base,
// called when a ticket is hung up/closed. Unlike the widget (always mounted
// hidden, so its globals were always available), the native chat components
// only exist while their surface is open - so this is a plain function
// kwikweb calls directly on hangup, not a window-global bridge.
const closeAllConversations = async (rawExternalId) => {
    if (!rawExternalId) return

    const user = getSession()
    if (!user?.profile?.enterprise?.has_assistant || !user?.profile?.has_assistant) return

    const agentId = user.profile.agent.id
    const loginRes = await api.post(`/api/IV/agents/${agentId}/assistant_login/`)
    if (loginRes.status !== 200) return

    const accessToken = loginRes.data['access_token']
    const assistantUrl = loginRes.data['assistant_url']
    const accountcode = user.profile.enterprise.assistant_accountcode_id

    const kbs = await fetchAllKnowledgeBases(assistantUrl, accessToken, accountcode)

    await Promise.all(
        kbs.map((kb) => cortexDelete(`${assistantUrl}/ai/conversations/${kb.id}${rawExternalId}`, accessToken))
    )
}

export default closeAllConversations
